import DateTimeBox from './src/DateTimeBox'

DateTimeBox.install = function (Vue) {
    Vue.component(DateTimeBox.name, DateTimeBox);
};

export default DateTimeBox;